'use strict';

/* eslint no-undef: "off" */
define('couponCard',['svgIcon'], function (svgIcon) {
  return {
    template: '\n      <div\n        class="xp-card-bag__card"\n        :class="{\n          \'is-expired\': expired,\n          \'has-action\': showAction\n        }"\n        @click.prevent="handleClick"\n      >\n        <span class="xp-card-bag__ticket">\n          <svg-icon width="57" height="64" type="coupon" :color="expired ? \'#D9D9D9\' : \'\'"></svg-icon>\n          <span class="xp-card-bag__ticket-text" v-text="label"></span>\n        </span>\n        <span class="xp-card-bag__content">\n          <span v-if="showAmount" class="xp-card-bag__amount" v-text="formattedAmount"></span>\n          <span class="xp-card-bag__name" v-text="name"></span>\n          <span class="xp-card-bag__desc" v-text="desc"></span>\n          <div class="xp-card-bag__footer">\n            <span v-if="dateText" class="xp-card-bag__date" v-text="dateText"></span>\n            <button\n              v-if="showAction"\n              type="button"\n              class="xp-card-bag__action"\n              :disabled="actionDisabled"\n              @click.stop.prevent="handleActionClick"\n              v-text="actionText"\n            ></button>\n          </div>\n        </span>\n        <img v-if="expired" class="xp-card-bag__expired" :src="expiredImage" alt="expired" />\n      </div>\n    ',
    props: {
      amount: {
        type: [String, Number],
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      desc: {
        type: String,
        default: ''
      },
      startDate: {
        type: [String, Number],
        default: ''
      },
      endDate: {
        type: [String, Number],
        default: ''
      },
      expired: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: 'DISCOUNT'
      },
      showAction: {
        type: Boolean,
        default: false
      },
      actionText: {
        type: String,
        default: 'GET'
      },
      actionDisabled: {
        type: Boolean,
        default: false
      },
      hideAmount: {
        type: Boolean,
        default: false
      }
    },
    components: {
      svgIcon: svgIcon
    },
    computed: {
      expiredImage: function expiredImage() {
        return require.toUrl('images/discount_code/coupon_expired.png');
      },
      showAmount: function showAmount() {
        return !this.hideAmount && !!this.formattedAmount;
      },
      formattedAmount: function formattedAmount() {
        var raw = this.amount;
        if (raw === null || raw === undefined || raw === '') {
          return '';
        }

        if (typeof raw === 'number') {
          return this.normalizeCurrency(raw);
        }

        var text = String(raw).trim();
        if (!text) {
          return '';
        }

        if (/₦/.test(text)) {
          return this.normalizeCurrencyText(text);
        }

        var compactText = text.replace(/,/g, '');
        if (/^-?\d+(\.\d+)?$/.test(compactText)) {
          return this.normalizeCurrency(Number(compactText));
        }

        return text;
      },
      dateText: function dateText() {
        var start = this.formatDate(this.startDate);
        var end = this.formatDate(this.endDate);

        if (start && end) {
          return start + ' - ' + end;
        }

        return end || start || '';
      }
    },
    methods: {
      normalizeCurrency: function normalizeCurrency(value) {
        var isNegative = Number(value) < 0;
        var absoluteValue = Math.abs(Number(value));
        var hasDecimal = Math.abs(value % 1) > 0;
        var formatted = hasDecimal ? absoluteValue.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) : absoluteValue.toLocaleString('en-US');

        return (isNegative ? '-₦ ' : '₦ ') + formatted;
      },
      normalizeCurrencyText: function normalizeCurrencyText(value) {
        var text = String(value || '').replace(/,/g, '').replace(/\s+/g, ' ').trim();
        var match = text.match(/^-?\s*₦\s*(-?\d+(?:\.\d+)?)$|^₦\s*(-?\d+(?:\.\d+)?)$|^-?\s*(\d+(?:\.\d+)?)\s*₦$/);

        if (match) {
          var numericText = match[1] || match[2] || match[3];
          if (numericText !== undefined) {
            var isNegative = /^-/.test(text) || /^-/.test(numericText);
            var amount = Math.abs(Number(numericText));
            if (!Number.isNaN(amount)) {
              return this.normalizeCurrency(isNegative ? -amount : amount);
            }
          }
        }

        return text;
      },
      formatDate: function formatDate(value) {
        if (value === null || value === undefined || value === '') {
          return '';
        }

        var text = String(value).trim();
        if (!text) {
          return '';
        }

        if (/^\d+$/.test(text)) {
          var numericValue = Number(text);
          var timestamp = text.length <= 10 ? numericValue * 1000 : numericValue;
          var date = new Date(timestamp);

          if (!Number.isNaN(date.getTime())) {
            return this.formatDateObject(date);
          }

          return text;
        }

        if (text.indexOf('-') > -1) {
          var parts = text.split('-');
          if (parts.length === 3) {
            return [parts[2], parts[1], parts[0]].join('.');
          }
          return text.replace(/-/g, '.');
        }

        return text;
      },
      formatDateObject: function formatDateObject(date) {
        if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
          return '';
        }

        var year = date.getUTCFullYear();
        var month = String(date.getUTCMonth() + 1).padStart(2, '0');
        var day = String(date.getUTCDate()).padStart(2, '0');

        return day + '.' + month + '.' + year;
      },
      handleClick: function handleClick() {
        this.$emit('click');
      },
      handleActionClick: function handleActionClick() {
        if (this.actionDisabled) {
          return;
        }

        this.$emit('action-click');
      }
    }
  };
});
